import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import '../../styles/Tooltip.css';

const Tooltip = ({ content, children }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <span className="help-icon-container">
            {children}
            <span 
                className="help-icon"
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
            >
                <FontAwesomeIcon icon={faQuestionCircle} />
            </span>
            {isVisible && (
                <div className="help-tooltip">
                    {content}
                </div>
            )}
        </span>
    );
};

export default Tooltip;
